import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
//
// Components
//
import { VSpecLocalSpecial } from './v-spec-local-special';
import { AppMenuComponentModule } from '../../../shared/components/app-menu/app-menu.module';
import { VehicleDetailHeaderComponentModule } from '../../../shared/components/vehicle-detail-header/vehicle-detail-header.component.module';
import { SharedModule } from '../../../shared/shared.module';
//
// Library Components
//
import { RtiLocalSpecialCardModule } from '../../../../lib/angular/component/common/rti-local-special-card/rti-local-special-card.module';
import { RtiModalDialogModule } from '../../../../lib/angular/component/general/rti-modal-dialog/rti-modal-dialog.module';
import { RtiDirectiveModule } from '../../../../lib/angular/directive/rti-directive.module';

@NgModule({
  imports: [
    CommonModule,
    RtiLocalSpecialCardModule,
    MatIconModule,
    RtiModalDialogModule,
    RtiDirectiveModule,
    AppMenuComponentModule,
    VehicleDetailHeaderComponentModule,
    SharedModule
  ],
  declarations: [
    VSpecLocalSpecial
  ],
  exports: [
    VSpecLocalSpecial
  ]
})

export class VSpecLocalSpecialModule {
}
